module.exports = __webpack_public_path__ + "media/app/images/vk-a38742b1b8a25b71847f6282f4e22f07.png";